import { useEffect, useState } from 'react'

export interface UseInvokeAsyncResult {
  error?: Error
  loading: boolean
  result: unknown
}

export interface UseInvokeAsyncOptions {
  onCompleted?: (result: unknown) => void
  onError?: (reason: Error) => void
}

export default function useInvokeAsync(
  callback: () => unknown,
  debug = false,
  options?: UseInvokeAsyncOptions
): UseInvokeAsyncResult {
  const [value, setValue] = useState<unknown>(undefined)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error>()
  const { onCompleted, onError } = options !== undefined ? options : ({} as UseInvokeAsyncOptions)

  useEffect(() => {
    setLoading(true)
    const invoke = async (): Promise<void> => {
      try {
        const value = await callback()
        setValue(value)
        onCompleted?.(value)
      } catch (err: unknown) {
        if (err instanceof Error) {
          debug && console.error(err)
          setError(err)
          onError?.(err)
        }
      } finally {
        setLoading(false)
      }
    }
    void invoke()
  }, [callback, debug, onCompleted, onError, options])

  return { error, loading, result: value }
}
